import { useContext } from "react";
import { WorkspaceContext } from "src/context/workspace";
import { classNames } from "src/helpers/classNames";

export default function RichTextEmbed({ content }) {
  const { details: workspaceDetails } = useContext(WorkspaceContext);

  const renderBlock = (block) => {
    switch (block.type) {
      case "paragraph":
        return (
          <p
            key={block.id}
            dangerouslySetInnerHTML={{ __html: block.data.text }}
          />
        );

      case "header": {
        const Tag = `h${block.data.level || 2}`;
        return (
          <Tag
            key={block.id}
            className="ce-header"
            dangerouslySetInnerHTML={{ __html: block.data.text }}
          />
        );
      }

      case "list": {
        const { style, items } = block.data;

        switch (style) {
          case "checklist":
            return (
              <ul
                key={block.id}
                className="checklist">
                {items.map((item, idx) => (
                  <li key={idx}>
                    <input
                      type="checkbox"
                      checked={item.meta?.checked}
                      readOnly
                    />
                    <span dangerouslySetInnerHTML={{ __html: item.content }} />
                  </li>
                ))}
              </ul>
            );

          case "ordered":
          case "unordered": {
            const ListTag = style === "ordered" ? "ol" : "ul";

            return (
              <ListTag key={block.id}>
                {items.map((item, idx) => (
                  <li
                    key={idx}
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  />
                ))}
              </ListTag>
            );
          }

          default:
            return null;
        }
      }

      case "code":
        return (
          <pre key={block.id}>
            <code>{block.data.code}</code>
          </pre>
        );

      case "quote":
        return (
          <blockquote key={block.id}>
            <p dangerouslySetInnerHTML={{ __html: block.data.text }} />
            {block.data.caption && <cite>{block.data.caption}</cite>}
          </blockquote>
        );

      case "delimiter":
        return <hr key={block.id} />;

      case "table": {
        const content = block.data.content || [];
        return (
          <table
            key={block.id}
            className="table-auto border border-gray-300">
            <tbody>
              {content.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td
                      key={cellIndex}
                      className="border px-2 py-1"
                      dangerouslySetInnerHTML={{ __html: cell }}
                    />
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        );
      }

      default:
        return null;
    }
  };

  return (
    <div className={classNames("relative h-full w-full")}>
      <div
        className={"editorjs-content relative z-0 mx-auto h-full w-full overflow-auto "}
        style={{ maxWidth: workspaceDetails?.max_width || "100%" }}>
        {content?.rich_text?.length > 0 && content?.rich_text?.map((block) => renderBlock(block))}
      </div>
    </div>
  );
}
